<div class="confirmation-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ title }}</h2>
    <button class="close-btn" (click)="onCancel()">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="dialog-body">
    <p class="dialog-message">{{ message }}</p>

    <div class="reason-input-wrap" *ngIf="showReasonInput">
      <label class="reason-label">
        {{ reasonLabel }}<span class="required-star" *ngIf="reasonRequired">*</span>
      </label>
      <textarea
        class="reason-textarea"
        [(ngModel)]="reason"
        rows="3"
        placeholder="Enter {{ reasonLabel | lowercase }}..."
      ></textarea>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onCancel()">
      {{ cancelButtonText }}
    </button>
    <button class="btn btn-confirm" (click)="onConfirm()" [disabled]="!canConfirm">
      {{ confirmButtonText }}
    </button>
  </div>
</div>
